import axios from "axios";
import { authenticatedApiConfig, generateURL } from "./BaseApiService";
export class GlobalAdminSkillEvalService {
    constructor(authenticationProvider, environment) {
        this.authenticationProvider = authenticationProvider;
        this.environment = environment;
    }
    async listAllAiPartners() {
        const response = await axios.get(generateURL(this.environment.API_BASE_URL, "/admin/skill-eval/ai-partners"), await authenticatedApiConfig(this.authenticationProvider));
        return response.data;
    }
    async listRunsByProject(projectId, limit, offset) {
        const base = generateURL(this.environment.API_BASE_URL, "/admin/skill-eval/projects/:projectId/runs", { projectId });
        const response = await axios.get(`${base}?limit=${limit}&offset=${offset}`, await authenticatedApiConfig(this.authenticationProvider));
        return response.data;
    }
    async listRuns(patientId, limit, offset) {
        const base = generateURL(this.environment.API_BASE_URL, "/admin/patients/:patientId/skill-eval/runs", { patientId });
        const response = await axios.get(`${base}?limit=${limit}&offset=${offset}`, await authenticatedApiConfig(this.authenticationProvider));
        return response.data;
    }
    async getRun(runId) {
        var _a;
        try {
            const response = await axios.get(generateURL(this.environment.API_BASE_URL, "/admin/skill-eval/runs/:runId", { runId }), await authenticatedApiConfig(this.authenticationProvider));
            return response.data;
        }
        catch (e) {
            if (axios.isAxiosError(e) && ((_a = e.response) === null || _a === void 0 ? void 0 : _a.status) === 404)
                return null;
            throw e;
        }
    }
    async submitReview(runId, req) {
        const response = await axios.post(generateURL(this.environment.API_BASE_URL, "/admin/skill-eval/runs/:runId/review", { runId }), req, await authenticatedApiConfig(this.authenticationProvider));
        return response.data;
    }
}
